import { Component, ElementRef, HostListener, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import { DataObject } from 'src/app/core/model/data-model/data-object.model';
import { Links, Link } from 'src/app/core/model/response.model';
import { ClientLayoutItem } from '@mmlogic/components';
import { ApiClientService } from 'src/app/core/services/api-client.service';

@Component({
    selector: 'app-object-search',
    templateUrl: './object-search.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ObjectSearchComponent implements OnInit {
  @Input() layoutItem: ClientLayoutItem;
  @Input() tenantCode: string;
  @ViewChild('searchInput') searchInput: ElementRef;

  data: DataObject[] | null;
  links: Links;

  filterSubject = new Subject<string>();
  refreshSubject = new Subject<string>();

  constructor(private api: ApiClientService, private router: Router) { }

  @HostListener('document:keydown.escape')
  onKeydownHandler() {
    this.onClose()
  }

  ngOnInit(): void {
    this.refreshSubject.pipe(
      switchMap((url) => this.api.getObjectsByUrl(url)),
    ).subscribe((response) => {
      this.data = (Object.values(response._embedded) as DataObject[][]).flat();
      this.links = response._links;
    });

    this.filterSubject.pipe(
      filter((f) => f?.length > 1),
      distinctUntilChanged(),
      debounceTime(400),
    ).subscribe((f) => this.refreshSubject.next(this.api.getGlobalSearchUrl(this.tenantCode, f, this.layoutItem.search?.dataClass)));
  }

  onFilter() {
    this.filterSubject.next(this.searchInput.nativeElement.value);
  }

  selectDataObject(uri: string) {
    this.onClose();
    this.router.navigateByUrl(uri);
  }

  navigate(link: Link) {
    this.refreshSubject.next(link.href);
  }

  onClose() {
    this.data = null
    this.searchInput.nativeElement.value = ''
  }
}
